import axios from "axios";
import { getActiveProfileId } from "@/lib/profileStorage";

/**
 * Builds PayPhone checkout URL.
 * optionalParameter formats:
 * - `${userId}|profile|basic|premium` — new paid profile
 * - `${userId}|${profileId}|basic|premium`
 * - `${userId}|${profileId}|basic|premium|renew` — renewal
 * - `${userId}|slot` — legacy extra-slot payments
 * - legacy `${userId}-${purchaseType}`
 */
export const generatePaymentUrl = async (
  totalAmount,
  reference,
  userId,
  purchaseType,
  profileId,
  purchaseContext = "plan"
) => {
  const IVA_RATE = 0.15;

  const baseImponible = parseFloat((totalAmount / (1 + IVA_RATE)).toFixed(2));
  const tax = parseFloat((totalAmount - baseImponible).toFixed(2));

  let optionalParameter;
  if (purchaseContext === "new-profile") {
    optionalParameter = `${userId}|profile|${purchaseType}`;
  } else if (purchaseContext === "renewal") {
    const resolvedProfileId = profileId || getActiveProfileId();
    if (!resolvedProfileId) {
      throw new Error("La renovación requiere un perfil existente.");
    }
    optionalParameter = `${userId}|${resolvedProfileId}|${purchaseType}|renew`;
  } else if (purchaseType === "slot") {
    optionalParameter = `${userId}|slot`;
  } else {
    const resolvedProfileId = profileId || getActiveProfileId();
    if (resolvedProfileId) {
      optionalParameter = `${userId}|${resolvedProfileId}|${purchaseType}`;
    } else {
      optionalParameter = `${userId}-${purchaseType}`;
    }
  }

  const productQuery =
    purchaseType === "slot"
      ? "slot"
      : purchaseType === "premium"
        ? "premium"
        : "basic";
  const contextQuery =
    purchaseContext === "new-profile"
      ? "&context=new-profile"
      : purchaseContext === "renewal"
        ? "&context=renewal"
        : "";

  const requestBody = {
    amount: Math.round(totalAmount * 100),
    amountWithTax: Math.round(baseImponible * 100),
    tax: Math.round(tax * 100),
    service: 0,
    tip: 0,
    currency: "USD",
    clientTransactionId: `CTX-${Date.now()}`,
    storeId: process.env.NEXT_PUBLIC_PAYPHONE_STORE_ID,
    reference: reference,
    responseUrl: `${window.location.origin}/payment-result?p=${productQuery}${contextQuery}`,
    cancellationUrl: `${window.location.origin}`,
    countryCode: "593",
    optionalParameter,
  };

  const { data } = await axios.post(
    "https://pay.payphonetodoesposible.com/api/button/v2/Prepare",
    requestBody,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_PAYPHONE_TOKEN}`,
      },
    }
  );

  return data.payWithCard;
};
